import React from 'react';

import ptcAdded from '../../images/PTC-added.png';
import ptcLicense from '../../images/PTC-license.png';

const HelpPage = ({ name }) => {
  switch (name) {
    case 'appSubmitted':
      return (
        <div className="dashboard__help">
          <div>
            {' '}
            An Autzu account specialist is reviewing your documents to ensure you are eligible for an Uber Driver
            account.
          </div>{' '}
          <div>
            {' '}
            Once your Uber Driver account is set up, we will send you instructions in an email to complete your
            background check.
          </div>
        </div>
      );
    case 'greenlight':
      return (
        <div className="dashboard__help">
          <div>
            {' '}
            Please visit the Uber Greenlight Hub and ask for your Uber Driver account to be added to the Autzu Fleet.{' '}
          </div>{' '}
          <div>
            {' '}
            Uber Greenlight Hub Locations and Opening hours:{' '}
            <a href="https://www.uber.com/en-CA/drive/toronto/contact/" target="_blank">
              t.uber.com/torhours
            </a>{' '}
          </div>{' '}
          <div>
            If your Uber Driver account is not yet active after being added, you will need to complete the background
            check.
          </div>
        </div>
      );
    case 'background':
      return (
        <div className="dashboard__help">
          <div> The Uber Background Screening will review your driving record and criminal history. </div>{' '}
          <div>
            {' '}
            Check your email for the online background screening from Triton Canada Inc. (subject: “Triton Canada Inc -
            Online Forms”){' '}
          </div>{' '}
          <div>This whole process will only take you about 10 minutes.</div>
          <div> If you haven’t received this email, please contact us.</div>
        </div>
      );
    case 'ptcYes':
      return (
        <div className="dashboard__help">
          <div>
            <b>What is the PTC License?</b>
          </div>
          <div>
            {' '}
            The PTC license allows you to pick up passenger trips in the City of Toronto, Mississauga, and Oakville.
          </div>{' '}
          <div>This is the final step in setting up your Uber account before we activate your Autzu account.</div>{' '}
          <div>
            {' '}
            <b>I have an existing PTC License </b>
          </div>
          <div>You can request this from Uber Support for a copy of your PTC License. It will look like this:</div>
          <img src={ptcLicense} alt="ptc" />
          <div>
            Please make sure that the PTC License is:
            <ul>
              <li>Issued to the Uber Driver account in Autzu fleet (you can check with Uber on this)</li>
              <li>Still Active and Valid (has not expired yet)</li>
            </ul>
          </div>
          <div>
            <b>I am waiting to be issued a PTC License</b>
          </div>
          <div>
            You will receive an email from Uber with the subject: “Important update about your rideshare license”. Once
            you receive it, please forward it to us at <a href="mailto:info@autzu.com">info@autzu.com</a> so that we can activate your Autzu account. It
            will look like this:
          </div>
          <img src={ptcAdded} alt="ptc" />
        </div>
      );
    case 'ptcNo':
      return (
        <div className="dashboard__help">
          <div>
            {' '}
            <b> What is the PTC License?</b>
          </div>
          <div>
            The PTC license allows you to pick up passenger trips in the City of Toronto, Mississauga, and Oakville.
            Since you are picking up Autzu cars from downtown Toronto, we make sure you have an active PTC license
            before you begin so you may have the best experience.{' '}
          </div>
          <div>This is the final step in setting up your Uber account before we activate your Autzu account.</div>
          <div>
            {' '}
            Your Uber Driver account must be active and also in the Autzu fleet before the PTC License process begins.
          </div>
          <div>
            <b> What’s next? </b>
          </div>
          <div>
            We will receive a notification in the next few days confirming that your PTC License has been issued and
            your Autzu account will be activated. If you haven’t received an update from us, please contact us.
          </div>
        </div>
      );
    default:
      return null;
  }
};

export default HelpPage;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/HelpPage.js